module.exports = __webpack_public_path__ + "static/media/AboutPage__Jerron.45d2a0cd.jpg";